
import React, { useEffect } from 'react';
import { useInteractiveTutorial } from '@/hooks/useInteractiveTutorial';

interface TutorialManagerProps {
  children: React.ReactNode;
  onStepAction?: (actionType: string) => void;
}

const TutorialManager: React.FC<TutorialManagerProps> = ({ children, onStepAction }) => {
  const { isActive, currentStep, nextStep } = useInteractiveTutorial();

  useEffect(() => {
    if (!isActive || !currentStep) return;

    // Listen for form submissions and other tutorial-relevant events
    const handleFormChange = () => {
      if (currentStep.action === 'type') {
        const timer = setTimeout(() => {
          nextStep();
        }, 1000); // Give user time to see their input
        return () => clearTimeout(timer);
      }
    };

    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const tutorialTarget = target.closest(`[data-tutorial="${currentStep.targetSelector?.replace('[data-tutorial="', '').replace('"]', '')}"]`);
      
      if (tutorialTarget && currentStep.action === 'click') {
        setTimeout(() => {
          nextStep();
        }, 500); // Small delay to let the click action complete
      }
    };

    if (currentStep.action === 'click') {
      document.addEventListener('click', handleClick);
    }

    if (currentStep.action === 'type') {
      document.addEventListener('input', handleFormChange);
    }

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('input', handleFormChange);
    };
  }, [isActive, currentStep, nextStep]);

  return <>{children}</>;
};

export default TutorialManager;
